import Constant from '@/const';
import axios from 'axios';

const getAllVisits = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/visitors/data'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getAllVisits;
